<template>
  <b-modal :id="modalId" :title="modalTitle" @shown="$emit('show')">
    <div slot="modal-header">
      <button
        type="button"
        class="close"
        aria-label="Close"
        @click="closeModal"
      >
        <span aria-hidden="true">&times;</span>
      </button>
      <h4 class="modal-title">{{ modalTitle }}</h4>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div
          class="form-group"
          :class="{ 'has-error': support.errors.includes('category_id') }"
        >
          <label for="supportCategory" class="control-label"
          >Выберите категорию вашего вопроса:</label
          >
          <select
            id="supportCategory"
            class="show-tick form-control"
            v-model="support.form.category_id"
          >
            <option
              v-for="category in supportCategories"
              v-bind:key="category.id"
              :value="category.id"
            >
              {{ category.name }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-md-12">
        <div
          class="form-group"
          :class="{ 'has-error': support.errors.includes('theme') }"
        >
          <label for="supportTheme" class="control-label">Тема</label>
          <input
            type="text"
            class="form-control"
            id="supportTheme"
            v-model="support.form.theme"
            placeholder=""
          />
        </div>
      </div>

      <div class="col-md-12">
        <div
          class="form-group"
          :class="{ 'has-error': support.errors.includes('message') }"
        >
          <label for="supportMessage" class="control-label"
          >Текст сообщения</label
          >
          <textarea
            class="form-control"
            id="supportMessage"
            v-model="support.form.message"
            rows="3"
          ></textarea>
        </div>
      </div>

      <div class="col-md-12">
        <div class="panel panel-default">
          <div class="panel-heading">Напоминание</div>
          <div class="panel-body">
            Мы отправим ответ на почту, которая указана в аккаунте.
          </div>
        </div>
      </div>
    </div>
    <template v-slot:modal-footer>
      <div class="row">
        <div class="col-md-12">
          <button
            type="button"
            class="btn btn-success btn-block"
            :disabled="support.sending"
            @click="submitSupportModal"
          >
            Отправить вопрос
          </button>
        </div>
      </div>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: 'SupportModal',

  props: {
    modalId: {
      type: String,
      required: true
    },

    modalTitle: {
      type: String,
      default: 'Техническая поддержка'
    },

    support: {
      type: Object,
      required: true
    },

    supportCategories: {
      type: Array,
      default: () => []
    }
  },

  methods: {
    closeModal () {
      this.$bvModal.hide(this.modalId)
    },

    submitSupportModal () {
      this.$emit('submit-support-modal')
    }
  }
}
</script>
